<template>
    <q-layout style="background: #f1f2f4" view="hHh lpR fFf">
        <q-dialog full-width v-model="dialogNuevoDeudor" persistent>
            <Deudor></Deudor>
        </q-dialog>

        <q-dialog v-model="confirm" persistent>
            <q-card v-if="deudornotrabajado">
                <q-card-section class="row items-center">
                    <q-avatar icon="mdi-alert" color="primary" text-color="white" />
                    <span class="q-ml-sm">Estas seguro de cambiar el estatus del usuario {{ deudornotrabajado.rfc + " "
                        + deudornotrabajado.nombre
                        }}?</span>
                </q-card-section>

                <q-card-actions align="right">
                    <q-btn flat label="Cerrar" color="primary" v-close-popup />
                    <q-btn flat label="Cambiar estatus" color="primary" @click="putDeudorNoTrabajado()" />
                </q-card-actions>
            </q-card>
        </q-dialog>

        <q-dialog v-model="dialog" persistent>
            <q-card style="min-width: 100%; max-height: 90vh;">
                <q-card-section>
                    <div class="text-h6">Vista previa de datos</div>
                </q-card-section>

                <q-card-section class="q-pa-none">
                    <q-table :columns="columns2" :data="rows" row-key="__rowNum__" dense flat bordered
                        no-data-label="No hay datos para mostrar" virtual-scroll>
                        <!-- Columna de acciones -->
                        <template v-slot:body-cell-acciones="props">
                            <q-td align="center">
                                <q-btn flat dense round color="negative" icon="delete"
                                    @click="eliminarFila(props.row)" />
                            </q-td>
                        </template>
                    </q-table>
                </q-card-section>

                <q-card-actions align="right">
                    <q-btn color="positive" label="Guardar Lista" @click="guardarLista" />
                    <q-btn label="Cerrar" color="primary" @click="cerrarDialog" />
                </q-card-actions>
            </q-card>
        </q-dialog>

        <div class="q-pa-xl q-mx-smq-gutter-sm">
            <q-card class="shadow-0" style="width: 100%;">
                <q-card-section full-width class="text-white">
                    <div class="row">
                        <q-toolbar class="q-mb-md">
                            <!-- <q-btn color="primary" icon="mdi-plus" label="Nuevo Contribuyente" @click="nuevoDeudor()" /> -->
                            <!-- <q-btn color="primary" icon="mdi-plus" label="Cargar Excel" @click="cargarExcel()" /> -->
                            <q-btn label="Subir Excel" color="primary" @click="$refs.fileInput.click()" />
                            <input type="file" ref="fileInput" accept=".xlsx, .xls, .csv" style="display: none"
                                @change="handleFileUpload" />
                            <q-space />
                            <q-select dense filled v-model="estadoDedudor" style="width:300px" fill-input
                                :options="['Pendiente', 'Asignado', 'NoTrabajado']" label="Consultar por Estatus">
                                <template v-slot:no-option>
                                    <q-item>
                                        <q-item-section class="text-grey">
                                            No results
                                        </q-item-section>
                                    </q-item>
                                </template>

                                <template v-slot:after>
                                    <q-btn round color="primary" icon="mdi-magnify" @click="getListaDeudores()">
                                        <q-tooltip>
                                            Actualizar Lista
                                        </q-tooltip>
                                    </q-btn>
                                </template>
                            </q-select>


                        </q-toolbar>
                        <div class="col-12 col-md-12">
                            <q-table dense :data="data" :columns="columns" row-key="name"
                                title="Lista de Contribuyentes" :filter="filter" :loading="loading"
                                :pagination="{ rowsPerPage: 10 }">
                                <template v-slot:top-right>
                                    <q-input filled dense debounce="300" v-model="filter" placeholder="Buscar">
                                        <template v-slot:append>
                                            <q-icon name="search" />
                                        </template>
                                    </q-input>
                                </template>

                                <template v-slot:body="props">
                                    <q-tr :props="props">
                                        <q-td key="acciones" :props="props" align="center">
                                            <q-btn flat dense round color="negative" icon="delete"
                                                @click="noTrabajado(props.row)"
                                                v-if="props.row.estatus == 'Pendiente'" />
                                        </q-td>

                                        <q-td key="nombre" :props="props">
                                            {{ props.row.nombre }}
                                        </q-td>
                                        <q-td key="rfc" :props="props">
                                            {{ props.row.rfc }}
                                        </q-td>
                                        <q-td key="placa" :props="props">
                                            {{ props.row.placa }}
                                        </q-td>
                                        <q-td key="codigo_postal" :props="props">
                                            {{ props.row.codigo_postal }}
                                        </q-td>
                                        <q-td key="municipio_deudor" :props="props">
                                            {{ props.row.municipio_deudor }}
                                        </q-td>
                                        <q-td key="localidad" :props="props">
                                            {{ props.row.localidad }}
                                        </q-td>
                                        <q-td key="fraccionamiento_colonia" :props="props">
                                            {{ props.row.fraccionamiento_colonia }}
                                        </q-td>
                                        <q-td key="calle" :props="props">
                                            {{ props.row.calle }}
                                        </q-td>
                                        <q-td key="estatus" :props="props">
                                            <q-badge v-if="props.row.estatus == 'Pendiente'" color="blue">
                                                {{ props.row.estatus }}
                                            </q-badge>
                                            <q-badge v-if="props.row.estatus == 'Asignado'" color="green">
                                                {{ props.row.estatus }}
                                            </q-badge>
                                            <q-badge v-if="props.row.estatus == 'NoTrabajado'" color="red">
                                                {{ props.row.estatus }}
                                            </q-badge>

                                        </q-td>
                                    </q-tr>
                                </template>
                            </q-table>
                        </div>
                    </div>
                </q-card-section>
            </q-card>
        </div>

    </q-layout>
</template>
<script>
import axios from 'axios'
import { QSpinnerGrid } from 'quasar'
import Deudor from './Deudor.vue'
import * as XLSX from 'xlsx';
export default {
    name: 'Home',
    components: {
        Deudor
    },
    data() {
        return {
            columnasEsperadas: [
                'RFC',
                'NOMBRE',
                'IDENTIFICADOR',
                'CALLE',
                'FRACCIONAMIENTO O COLONIA',
                'LOCALIDAD',
                'MUNICIPIO',
                'CODIGO POSTAL',
                'TOTAL A PAGAR'
            ],
            dialog: false,
            columns2: [],
            rows: [],
            columns: [
                { name: 'acciones', align: 'center', label: 'Acciones', field: 'acciones', sortable: true },
                {
                    name: 'nombre',
                    field: 'nombre',
                    required: true,
                    label: 'Nombre',
                    align: 'left',
                    sortable: true,
                    classes: 'bg-grey-2 ellipsis',
                    headerClasses: 'bg-primary text-white'
                },
                { name: 'rfc', align: 'left', label: 'RFC', field: 'rfc', sortable: true },
                { name: 'placa', align: 'center', label: 'Identificador', field: 'placa', sortable: true },
                { name: 'codigo_postal', align: 'center', label: 'Código Postal', field: 'codigo_postal', sortable: true },
                { name: 'municipio_deudor', align: 'left', label: 'Municipio', field: 'municipio_deudor', sortable: true },
                { name: 'localidad', align: 'left', label: 'Localidad', field: 'localidad', sortable: true },
                { name: 'fraccionamiento_colonia', align: 'left', label: 'Fraccionamiento - Colonia', field: 'fraccionamiento_colonia', sortable: true },
                { name: 'calle', align: 'left', label: 'Calle', field: 'calle', sortable: true },
                { name: 'estatus', align: 'left', label: 'Estatus', field: 'estatus', sortable: true },
            ],
            filter: '',
            loading: false,
            dialogNuevoDeudor: false,

            deudor: {
                nombre: '',
                curp: '',
                direccion: '',
                colonia: '',
                cp: '',
                telefono: ''
            },
            banderaEdit: false,
            estadoDedudor: 'Pendiente',
            deudornotrabajado: false,
            confirm: false
        }
    },
    computed: {
        data() {
            return this.$store.state.listaDeudoresStore
        },
    },
    created() {
    },
    methods: {
        async getListaDeudores() {
            this.loading = true
            try {
                let response = await axios.get("Deudores/GetDeudores/" + this.estadoDedudor);
                this.$store.state.listaDeudoresStore = response.data.lista;
                this.loading = false
            } catch (error) {
                console.log(error);
                this.loading = false
            }
        },
        async putDeudor() {

        },
        nuevoDeudor() {
            this.banderaEdit = false
            this.dialogNuevoDeudor = true
            let deudor = {
                _id: "",
                tipo_placas: "",
                recaudacion: "",
                municipio: "",
                oficina: "",
                placa: "",
                nombre: "",
                rfc: "",
                fecha_registro: "",
                clave_vehicular: "",
                estatus_vehiculo: "",
                color: "",
                combustible: "",
                constancia: "",
                fecha_expedicion: "",
                marca: "",
                submarca: "",
                modelo: "",
                nrpv: "",
                numero_serie: "",
                reg_fed_vehi: "",
                tipo_vehi: "",
                version: "",
                tipo_transmision: "",
                uso_vehiculo: "",
                tipo_servicio: "",
                num_pasajeros: "",
                capacidad_carga: "",
                folio_regularizacion: "",
                tipo_persona: "",
                periodos_adeudo: "",
                ultimo_ejercicio_pagado: "",
                calle: "",
                fraccionamiento_colonia: "",
                localidad: "",
                municipio_deudor: "",
                codigo_postal: "",
                adeudos_sin_descuento: "",
                descuento: "",
                total_pagar_descuentos: "",
                estatus: 'Pendiente'
            }

            this.$store.state.deudorStore = { ...deudor }
        },

        editarDeudor(item) {
            this.deudor = item
            this.dialogNuevoDeudor = true
            this.banderaEdit = true
        },

        handleFileUpload(event) {

            const file = event.target.files[0];
            if (!file) return;
            this.$q.loading.show({ spinner: QSpinnerGrid, spinnerColor: 'primary', spinnerSize: 90, message: 'Obteniendo datos. Espere...', messageColor: 'white' })

            const reader = new FileReader();
            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });

                // Tomar la primera hoja
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];

                // Convertir a JSON
                const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: "" });

                if (jsonData.length > 0) {
                    // Validar que tenga todas las columnas esperadas
                    const columnasArchivo = Object.keys(jsonData[0]);
                    const faltantes = this.columnasEsperadas.filter(col => !columnasArchivo.includes(col));

                    if (faltantes.length > 0) {
                        this.$q.notify({
                            type: 'negative',
                            message: `El archivo no es válido. Faltan columnas: ${faltantes.join(', ')}`
                        });
                        this.$q.loading.hide()

                        return;
                    }

                    // Crear columnas para q-table
                    this.columns2 = [
                        ...this.columnasEsperadas.map(key => ({
                            name: key,
                            label: key,
                            field: key,
                            align: 'left',
                            sortable: true
                        })),
                        { name: 'acciones', label: 'Acciones', field: 'acciones', align: 'center' }
                    ];
                    this.$q.loading.hide()

                    this.rows = jsonData;
                    this.dialog = true;

                } else {
                    this.$q.loading.hide()

                    this.$q.notify({
                        type: 'warning',
                        message: 'El archivo no contiene datos'
                    });
                }
                this.$refs.fileInput.value = null;
            };
            reader.readAsArrayBuffer(file);
        },
        eliminarFila(fila) {
            this.rows = this.rows.filter(r => r !== fila);
        },
        cerrarDialog() {
            this.dialog = false
            this.rows = []
            this.columns2 = []
        },

        async guardarLista() {
            this.$q.loading.show({ spinner: QSpinnerGrid, spinnerColor: 'primary', spinnerSize: 90, message: 'Obteniendo datos. Espere...', messageColor: 'white' })

            const limpiar = (valor) => {
                return valor === null || valor === undefined
                    ? ""
                    : String(valor).trim();
            };

            const listaFinal = this.rows.map(row => ({
                rfc: limpiar(row['RFC']),
                nombre: limpiar(row['NOMBRE']),
                placa: limpiar(row['IDENTIFICADOR']),
                calle: limpiar(row['CALLE']),
                fraccionamiento_colonia: limpiar(row['FRACCIONAMIENTO O COLONIA']),
                localidad: limpiar(row['LOCALIDAD']),
                municipio_deudor: limpiar(row['MUNICIPIO']),
                codigo_postal: limpiar(row['CODIGO POSTAL']),
                total_pagar_descuentos: limpiar(row['TOTAL A PAGAR'] || "0"),
                // Datos por default
                georef: "-",
                adeudos_sin_descuento: "0",
                estatus: "Pendiente"
            }));
            console.log("Lista generada:", listaFinal);
            try {
                let response = await axios.post("Deudores/CargarExcel/", listaFinal);
                console.log(response)
                this.$q.notify({
                    type: 'positive',
                    position: 'top-right',
                    message: response.data
                });
                this.$q.loading.hide()

            } catch (error) {
                this.$q.notify({
                    type: 'negative',
                    position: 'top-right',
                    message: ''
                });
                this.$q.loading.hide()

                console.log(error)
            }
        },
        noTrabajado(item) {
            console.log(item)
            this.deudornotrabajado = item
            this.confirm = true
        },
        async putDeudorNoTrabajado() {
            this.$q.loading.show({ spinner: QSpinnerGrid, spinnerColor: 'primary', spinnerSize: 90, message: 'Cambiando estatus. Espere...', messageColor: 'white' })

            try {
                let response = await axios.put("Visita/PutEstatusVisitaNoTrabajado/" + this.deudornotrabajado._id);
                console.log(response)
                this.$q.notify({
                    type: 'positive',
                    position: 'top-right',
                    message: 'El contribuyente cambio de estatus.'
                });
                this.$q.loading.hide()
                this.deudornotrabajado = null
                this.confirm = false
            } catch (error) {
                this.$q.notify({
                    type: 'negative',
                    position: 'top-right',
                    message: 'Error al realizar la actulizacion'
                });
                this.$q.loading.hide()

                console.log(error)
            }
        }


    }
}
</script>